/**
 * Created by Alex Aguilar on 7/6/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('manageBoardingGate',{
                parent: 'app',
                url: '/manageBoardingGates?date',
                params: {
                    date: null
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/manageBoardingGate/manageBoardingGates.html',
                        controller: 'manageBoardingGateCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['adminFlight','aircrew']);
                            }],
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabAdminFlights('adminFlights')
                            }],
                            'flights': ['assignAirCrewService', '$stateParams', function(assignAirCrewService, $stateParams){
                                if ($stateParams.date == null) {
                                    $stateParams.date = (new Date()).getTime();
                                }

                                if($stateParams.date != ""){
                                    return assignAirCrewService.getAssingAirCrewByDate(parseInt($stateParams.date))
                                }else{
                                    return [];
                                }

                            }]
                        }
                    }
                }
            })
    }
})();


